/**
 * Returns a consistent display label for a dose item.
 * Used by both DoseList and DoseDetailsPanel to ensure
 * the list title and collapsible panel title match.
 */
export function getDoseLabel(
    planLabel?: string,
    summationType?: string
): string {
    return planLabel ?? summationType ?? 'Dose';
}
